export class User {
  isLogged() {
    return this.token().length != 0
  }

  token() {
    return document.querySelector("meta[name=token]").content
  }
}
